import Vue from 'vue';

export function studentHandBook() {
    return Vue.axios({
      url: '/api/parent/studentHandBook',
      method: 'get',
    })
}
